import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@fiverr-private/visuals';
import { translate } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { useLightboxContext } from '../LightboxContext';
import { LightboxArrowsProps } from '../types';
import LightboxArrow from './LightboxArrow';

const LightboxArrows = ({ dataTestId, prevButtonTestId, nextButtonTestId }: LightboxArrowsProps) => {
  const { nextSource, prevSource, selectedSourceIndex, maxSourceIndex } = useLightboxContext();

  return (
    <Container data-testid={dataTestId} hidden={{ default: true, sm: false }}>
      {selectedSourceIndex > 0 && (
        <LightboxArrow
          dataTestId={prevButtonTestId}
          aria-label={translate<string>('overlay.lightbox.previous')}
          direction="left"
          onClick={prevSource}
        >
          <ChevronLeftIcon color="grey_100" />
        </LightboxArrow>
      )}
      {selectedSourceIndex < maxSourceIndex && (
        <LightboxArrow
          dataTestId={nextButtonTestId}
          aria-label={translate<string>('overlay.lightbox.next')}
          direction="right"
          onClick={nextSource}
        >
          <ChevronRightIcon color="grey_100" />
        </LightboxArrow>
      )}
    </Container>
  );
};

LightboxArrows.displayName = 'LightboxArrows';

export default LightboxArrows;
